import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import WebFontLoader from 'webfontloader';
import 'babel-polyfill';

import { addLocaleData } from 'react-intl';

import fr from 'react-intl/locale-data/fr';
import en from 'react-intl/locale-data/en';
import nl from 'react-intl/locale-data/nl';
import de from 'react-intl/locale-data/de';

import 'moment/locale/fr';
import 'moment/locale/nl';
import 'moment/locale/de';

import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';


addLocaleData([...fr, ...en, ...nl, ...de]);

let locale;
// noinspection JSDeprecatedSymbols
const browserLanguage = localStorage.getItem('locale')
  || (navigator.languages && navigator.languages[0])
  || navigator.language
  || navigator.userLanguage
  || 'en-UK';
if (/^fr/.test(browserLanguage)) locale = 'fr';
else if (/^nl/.test(browserLanguage)) locale = 'nl';
else if (/^de/.test(browserLanguage)) locale = 'de';
else locale = 'en';

localStorage.locale = locale;

WebFontLoader.load({
  google: {
    families: ['Titillium Web:300,400,500,600,700,900', 'Material Icons'],
  },
});

ReactDOM.render(
  <BrowserRouter>
    <App locale={locale} />
  </BrowserRouter>
  ,
  document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js